/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteOfferNoteEntry$Params {
  id: number;
  noteEntryId: number;
}

export function deleteOfferNoteEntry(http: HttpClient, rootUrl: string, params: DeleteOfferNoteEntry$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteOfferNoteEntry.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('noteEntryId', params.noteEntryId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteOfferNoteEntry.PATH = '/offers/{id}/note-entries/{noteEntryId}';
